import { useCallback, useContext } from 'react';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';
import { SearchLoadingDispatchContext, SearchResultsDispatchContext } from '@/containers/WorkspaceGlobalSearch/Context';
import type { WorkspaceSearchFull } from '@trinity/chat';

export default function useSearchFetchQuantAnalyses() {
  const setResults = useContext(SearchResultsDispatchContext);
  const setLoading = useContext(SearchLoadingDispatchContext);

  const apiClient = useChatApiClient();

  const quantanalyses = useCallback(async ({ filters, size }: FetchData) => {
    const result = await apiClient.workspacesGlobalSearch.quantanalyses({
      filters,
      size,
    });

    if (result) {
      setResults(prev => ({
        ...prev,
        quantanalyses: result,
      }));
    }
  }, [apiClient, setResults]);

  const fetch = useCallback(({ filters, size }: FetchData) => {
    setLoading(prev => ({ ...prev, quantanalyses: { ...prev.quantanalyses, loading: true } }));
    Promise.all([
      new Promise<void>(resolve => setTimeout(() => resolve(), 250)),
      quantanalyses({ filters, size }),
    ])
      .then(() => {
        setLoading(prev => ({ ...prev, quantanalyses: { loading: false } }));
      });
  }, [quantanalyses, setLoading]);

  return fetch;
}

export { useSearchFetchQuantAnalyses };

type FetchData = {
  filters: WorkspaceSearchFull.QuantAnalyses.Filters;
  size: number;
};